class AppSettings {
  BaseApiUrl = "";
  GoogleMapsApiKey = "";
  ForceReloadBoardAfterHubEvents = 10;
  DaktelaDashboardUrl = "";
  DaktelaActivityUrl = "";

  loadFromObject(obj: any): void {
    this.BaseApiUrl = obj.BaseApiUrl;
    this.GoogleMapsApiKey = obj.GoogleMapsApiKey;
    this.ForceReloadBoardAfterHubEvents = obj.ForceReloadBoardAfterHubEvents;
    this.DaktelaDashboardUrl = obj.DaktelaDashboardUrl ?? "";
    this.DaktelaActivityUrl = obj.DaktelaActivityUrl ?? "";
  }
}

export const appSettings = new AppSettings();
